module.exports = {
    formatDate: function (timestamp) {
        const date = new Date(parseInt(timestamp));
        const day = ("0" + date.getDate()).slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    },
    formatTimestampToDate: function (timestamp) {
        const date = new Date(parseInt(timestamp));
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    // Parses a "DD/MM/YYYY" string typed by the user into a midnight-local
    // timestamp. Returns null if the string isn't a real calendar date
    // (rejects e.g. 31/02/2026, which JS Date would otherwise silently
    // roll over into March).
    parseDate: function (str) {
        const match = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/.exec(str || '');
        if (!match) {
            return null;
        }
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10);
        const year = parseInt(match[3], 10);
        const date = new Date(year, month - 1, day);
        if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
            return null;
        }
        return date.getTime();
    },
    // Parses free text typed by the user into a {start, end} timestamp range.
    // Accepts a single "DD/MM/YYYY" (used as both start and end) or two dates
    // separated by any non-digit text (e.g. "Dal 15/07/2026 al 20/07/2026",
    // "15/07/2026 - 20/07/2026"). Returns null if it can't confidently parse
    // exactly one or two valid dates.
    parseDateRange: function (str) {
        const self = this;
        const matches = (str || '').match(/\d{1,2}\/\d{1,2}\/\d{4}/g);
        if (!matches || matches.length === 0 || matches.length > 2) {
            return null;
        }
        const timestamps = matches.map(function (m) { return self.parseDate(m); });
        if (timestamps.some(function (t) { return t === null; })) {
            return null;
        }
        const start = timestamps[0];
        const end = timestamps.length === 2 ? timestamps[1] : timestamps[0];
        if (end < start) {
            return { start: end, end: start };
        }
        return { start: start, end: end };
    }
}
